import { Component, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { UploadApiService } from 'src/app/services/uploadapi.service';

@Component({
    selector: 'app-upload-tree-node',
    templateUrl: './upload-tree-node.component.html',
    styleUrls: ['./upload-tree-node.component.scss'],
    standalone: false
})
export class UploadTreeNodeComponent {
    @Output() reloadUploadHostory = new EventEmitter<boolean>();
    tooltip_position = 'above';
    constructor(
        private uploadApiService: UploadApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private customToastService: CustomToastService
    ) {}
    ngOnInit(): void {}
    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            let allowedTypes = [
                'application/vnd.ms-excel', // .xls
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            ];
            let errorMessage = 'Please select a .xls, or .xlsx file.';
            if (!allowedTypes.includes(input.files[0].type)) {
                this.customToastService.errorToast(errorMessage, 'Error');
                return;
            }
            this.ngxUiLoaderService.start();
            const file = input.files[0];
            if (file) {
                const formData = new FormData();
                formData.append('uploadSheet', file);
                this.uploadApiService.uploadFile(formData).subscribe(
                    (response: any) => {
                        if (response) {
                            if (response.success) {
                                this.customToastService.successToast('Your file was successfully submitted for data upload.', 'Success');
                            } else {
                                this.customToastService.errorToast(response.message, 'Error');
                            }
                            this.reloadUploadHostory.emit(true);
                            this.ngxUiLoaderService.stop();
                        } else {
                            this.customToastService.errorToast("Something went wrong , Please try again or contact administrator'", 'Error');
                            this.ngxUiLoaderService.stop();
                        }
                        input.value = ''; // 🔥 Reset here
                    },
                    (error) => {
                        this.customToastService.errorToast("Something went wrong , Please try again or contact administrator'", 'Error');
                        this.ngxUiLoaderService.stop();
                        input.value = ''; // 🔥 Reset here
                    }
                );
            } else {
                this.ngxUiLoaderService.stop();
            }
        }
    }
}
